import { gsap, TweenMax, Power1 } from "gsap";

document.addEventListener('DOMContentLoaded', () => {
    
    const btn = document.querySelectorAll('.js-lessmore');

    const init = ()=> {
        let lang = 0;
        document.documentElement.lang === 'en-EN' ? lang = 1 : false;
        
        const toggle = (ev, section, op)=> {
            TweenMax.to(section, 0.4, {
                height: ev,
                opacity: op,
                immediateRender: false,
                ease: Power1.easeOut
            });
        }
        
        for (let i = 0; i < btn.length; i++) {
            btn[i].addEventListener('click', (e) => {
                e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
                
                let _height = 0,
                     target = document.querySelector(e.currentTarget.dataset.el);
    
                if (target.classList.contains('show-all')) {
                    target.classList.remove('show-all');
                    btn[i].innerHTML = JSON.parse(e.currentTarget.dataset.more)[lang];
                    toggle(_height, target.querySelector('.full'), 0);

                } else {
                    target.classList.add('show-all');
                    btn[i].innerHTML = JSON.parse(e.currentTarget.dataset.less)[lang];
                    toggle('auto', target.querySelector('.full'), 1);
                }
                target.querySelectorAll('.js-lessmore')[1].innerHTML = JSON.parse(target.querySelectorAll('.js-lessmore')[1].dataset.less)[lang];
            })
        }
    };

    btn.length > 0 ? init() : false;
    
}, false);